// extracted by mini-css-extract-plugin
module.exports = {"itemPhoto":"_3Cvly","spacer":"_3ogBX"};